// @ts-nocheck
import * as React from 'react';
// Toasts — notification toast stack.

import Icon from '../common/Icon';

export default function Toasts({ items, onDismiss }) {
  return (
    <div className="toast-stack">
      {items.map((t) => (
        <div className="toast" key={t.id}>
          <div className="toast__icon">
            <Icon name="check" size={16} stroke={2.2} />
          </div>
          <div style={{ flex: 1 }}>
            <div className="toast__title">{t.title}</div>
            <div className="toast__sub">{t.sub}</div>
          </div>
          <button
            onClick={() => onDismiss(t.id)}
            style={{ background: "transparent", border: 0, color: "rgba(255,255,255,0.6)", cursor: "pointer", padding: 2 }}
            title="Dismiss"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" fill="none"><line x1="6" y1="6" x2="18" y2="18" /><line x1="18" y1="6" x2="6" y2="18" /></svg>
          </button>
        </div>
      ))}
    </div>
  );
}
